import { render, staticRenderFns } from "./AreaIncreaseCustomer.vue?vue&type=template&id=1c9ee13b&scoped=true&"
import script from "./AreaIncreaseCustomer.vue?vue&type=script&lang=js&"
export * from "./AreaIncreaseCustomer.vue?vue&type=script&lang=js&"
import style0 from "./AreaIncreaseCustomer.vue?vue&type=style&index=0&id=1c9ee13b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9ee13b",
  null
  
)

export default component.exports